'use es6';

import { createSelector } from 'reselect';
import SeamlessImmutable from 'seamless-immutable';
import { mapObject } from 'underscore';
import * as SmartWidgetTypes from 'DesignData/enums/SmartWidgetTypes';
import { EMPTY_OBJECT } from 'DesignData/lib/object';
import { getFilesById, getFoldersById } from 'DesignData/selectors/finder';
import { getAssetParentThemeFolderId } from 'DesignData/lib/themes/themes';
export const getCustomWidgetsData = state => state.customWidgets.widgets;
export const getCustomWidgetsOrder = state => state.customWidgets.order;
export const getCustomWidgetsFetchStatus = state => state.customWidgets.fetchStatus;
export const getCustomWidgetsIsInitialized = state => state.customWidgets.isInitialized;
export const getCustomWidgetsMappingFetchStatus = state => state.customWidgets.mappingFetchStatus;
export const getCustomWidgetsIsMappingInitialized = state => state.customWidgets.isMappingInitialized;

const getMapping = state => state.customWidgets.mapping;
/**
 * Enforces memoization of getCustomWidgetsByType()
 */


const getBuiltinWidgetsByModuleId = (() => {
  let result = EMPTY_OBJECT;
  return createSelector([getCustomWidgetsIsInitialized, getCustomWidgetsData], (isInitialized, widgets) => {
    if (!isInitialized) return result = EMPTY_OBJECT;
    const byModuleId = {};
    Object.values(widgets).forEach(widget => {
      if (!widget.default) return;
      byModuleId[widget.moduleId] = widget;
    });
    result = SeamlessImmutable.merge(result, byModuleId);
    return result;
  });
})();
/**
 * Builtin widgets by legacy type name.
 * No props needed.
 */


export const getCustomWidgetsByType = createSelector([getCustomWidgetsIsInitialized, getCustomWidgetsIsMappingInitialized, getBuiltinWidgetsByModuleId, getMapping], (isInitialized, isMappingInitialized, builtinWidgets, mapping) => {
  if (!(isInitialized && isMappingInitialized)) {
    return EMPTY_OBJECT;
  }

  const widgetsByType = {};
  Object.keys(mapping).forEach(type => {
    const moduleId = mapping[type];
    widgetsByType[type] = builtinWidgets[moduleId];
  });
  return SeamlessImmutable(widgetsByType);
}); // The original implementation was a noop.

export const getCustomWidgetsById = getCustomWidgetsData;

const getCustomWidgetId = (state, props) => props.customWidgetId;

export const getCustomWidget = createSelector([getCustomWidgetsById, getCustomWidgetId], (customWidgetsById, customWidgetId) => customWidgetsById[customWidgetId]);
export const getCustomWidgetsByName = createSelector([getCustomWidgetsData], widgets => {
  const byName = Object.keys(widgets).reduce((hash, wid) => {
    const widget = widgets[wid];
    return Object.assign({}, hash, {
      [widget.name]: widget
    });
  }, {});
  return SeamlessImmutable(byName);
});
export const getFieldsById = createSelector([getCustomWidgetsById], customWidgetsById => {
  return mapObject(customWidgetsById, widget => {
    return widget.fields;
  });
});
export const getSmartContentEligibleCustomWidgetsById = createSelector([getCustomWidgetsByType], customWidgetsByType => {
  const byId = Object.keys(customWidgetsByType).reduce((hash, widgetType) => {
    const customWidget = SmartWidgetTypes[widgetType] && customWidgetsByType[widgetType];

    if (customWidget) {
      hash[customWidget.id] = customWidget;
    }

    return hash;
  }, {});
  return SeamlessImmutable(byId);
});
export const getDefaultBlogContentTemplateSource = createSelector([getCustomWidgetsByType], customWidgetsByType => {
  const blogContentModule = customWidgetsByType.blog_content;
  if (!blogContentModule) return null;
  return blogContentModule.fields.reduce((defaultFields, field) => {
    defaultFields[field.name] = field.default;
    return defaultFields;
  }, {});
});
/**
 * Required props:
 *  - customWidgetId
 *
 * @returns {Number|Null}
 */

export const makeGetCustomWidgetParentThemeFolderId = () => {
  return createSelector([getFilesById, getFoldersById, getCustomWidgetId], getAssetParentThemeFolderId);
};